import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import PhoenixFormsV4Control from "./PhoenixFormsV4Control";
import PhoenixFormsV4ReadOnlyControl from "./PhoenixFormsV4ReadOnlyControl";
import PNXLabel from "./PNXLabel";

interface ReadOnlyProps {
  controlProps: controls.ContainerControl;
}

interface Props extends ReadOnlyProps {  
  onControlBlur: () => void;
};

const PhoenixSelectGroup = ({
  controlProps,
  onControlBlur,
} : Props) => {

  return <div>
    <PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>
    <ul>
      {controlProps.controls.map(item => <PhoenixFormsV4Control key={`selectgroupitem-${item.id}`} controlProps={item} parentControlProps={controlProps} parentOnBlur={onControlBlur} />)}
    </ul>
  </div>;
};

export const willPhoenixSelectGroupReadOnlyRender = (controlProps: controls.ContainerControl) => {
  return controlProps.controls.filter(c => {
    const sgi = c as controls.SelectGroupItem;
    return sgi.optionValue === sgi.value;
  }).length > 0;
};

export const PhoenixSelectGroupReadOnly = ({
  controlProps,
} : ReadOnlyProps) => {

  const selectedChildren = controlProps.controls.filter(c => {
    const sgi = c as controls.SelectGroupItem;
    return sgi.optionValue === sgi.value;
  });

  if (!selectedChildren.length) { // Don't render anything if none of the children are checked
    return null;
  }

  return <div>
    <PNXLabel>{controlProps.label}</PNXLabel>
    <div className="select-group-readonly-list">
      {selectedChildren.map(item => <PhoenixFormsV4ReadOnlyControl key={`selectgroupitem-${item.id}`} controlProps={item} parentControlProps={controlProps} />)}
    </div>
  </div>;
}; 

export default PhoenixSelectGroup;